module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hSMCP"))).then(() => parcelRequire('hEqeo'));